import { parse, isWithinInterval } from 'date-fns';
import { zonedTimeToUtc, format } from 'date-fns-tz';
import config from '@/config';

export function dateInBetween(date, filterString) {
  const dateToZeroTime = date.split(' ')[0] + ' 00:00:00';
  const dateRange = filterString.split(' — ');
  const startDateRaw = dateRange[0];
  const endDateRaw = dateRange[1] !== undefined ? dateRange[1] : dateRange[0];
  const startDate = parse(startDateRaw, config.dateTimeInputFormat, new Date());
  const endDate = parse(endDateRaw, config.dateTimeInputFormat, new Date());
  const testDate = parse(
    dateToZeroTime,
    config.dateTimeInputFormat,
    new Date()
  );
  return isWithinInterval(testDate, { start: startDate, end: endDate });
}

export function dateToLocal(date, inputFormat, outputFormat) {
  if (!date) return date;
  const parsedDate = parse(date, inputFormat, new Date());
  const zonedDate = zonedTimeToUtc(parsedDate, config.defaultTimezone);
  return format(zonedDate, outputFormat);
}
